'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withWindow = require('../helpers/withWindow');

var _withWindow2 = _interopRequireDefault(_withWindow);

var _AddFavorites = require('./AddFavorites');

var _AddFavorites2 = _interopRequireDefault(_AddFavorites);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _withWindow2.default)(_AddFavorites2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/AddFavorites/index.js
// module id = 259
// module chunks = 0